import { Injectable } from '@angular/core';
import confetti from 'canvas-confetti';

@Injectable({
  providedIn: 'root'
})
export class ConfettiService {

  constructor() { }
  colors;
  zIndex: number = 100;
  defaultZIndex: number = 100;
  defaultColors: string[] = ['#bb0000', '#ffffff'];
  duration = (2 * 1000);
  skew = 1;
  end;
  cannon(zIndexValue = this.defaultZIndex, colorsValue = this.defaultColors) {
    this.end = Date.now() + this.duration;
    this.colors = colorsValue;
    this.zIndex = zIndexValue;
    this.frame();
  }

  frame() {
    var timeLeft = this.end - Date.now();
    var ticks = Math.max(200, 500 * (timeLeft / this.duration));
    this.skew = Math.max(0.8, this.skew - 0.001);



    confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks: ticks,
      origin: {
        x: Math.random(),
        y: (Math.random() * this.skew) - 0.2
      },
      colors: [this.colors[Math.floor(Math.random() * this.colors.length)]],
      gravity: this.randomInRange(0.4, 0.6),
      scalar: this.randomInRange(0.4, 1),
      drift: this.randomInRange(-0.4, 0.4),
      zIndex: this.zIndex
    });

    
     // this.fire(0.25, {
    //   spread: 26,
    //   startVelocity: 55,
    // });
    // this.fire(0.2, {
    //   spread: 60,
    // });
    // this.fire(0.35, {
    //   spread: 100,
    //   decay: 0.91,
    //   scalar: 0.8
    // });
    // this.fire(0.1, {
    //   spread: 120,
    //   startVelocity: 25,
    //   decay: 0.92,
    //   scalar: 1.2
    // });
    // this.fire(0.1, {
    //   spread: 120,
    //   startVelocity: 45,
    // });

    // confetti({
    //   particleCount: 2,
    //   angle: 60,
    //   spread: 55,
    //   origin: { x: 0 },
    //   colors: colors,
    //   zIndex: zIndex
    // });
    // confetti({
    //   particleCount: 2,
    //   angle: 120,
    //   spread: 55,
    //   origin: { x: 1 },
    //   colors: colors,
    //   zIndex: zIndex
    // });

    if (Date.now() < this.end) {
      // requestAnimationFrame(this.frame);
      requestAnimationFrame(this.frame.bind(this));
    }

  }

  public fire(particleRatio, opts) {
    var count = 200;
    var defaults = {
      origin: { y: 0.7 }
    };
    confetti(Object.assign({}, defaults, opts, {
      particleCount: Math.floor(count * particleRatio),
      zIndex: this.zIndex,
      colors: this.colors
    }));
  }
  randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }


}
